import {
  FormErrorsAlert,
  FormItem,
  RadioGroupInput,
  TextAreaInput,
  TextInput,
} from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { RowElement } from '@framework/ui';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { AddressBookUserOrigin } from './AddressBookRecordSchema';

export interface IAddressBookRecordInnerFormProps {}

export function AddressBookRecordInnerForm(
  props: IAddressBookRecordInnerFormProps,
) {
  const { t } = useTranslation();
  const userOrigin = useWatch({ name: 'userOrigin' });

  return (
    <>
      <FormErrorsAlert />

      <FormItem
        name="userOrigin"
        label={t('address-book.edit.user-origin', 'Provenienza Utente')}
        help=""
      >
        <RadioGroupInput
          name="userOrigin"
          options={[
            {
              label: 'EU',
              value: AddressBookUserOrigin.EU,
            },
            {
              label: 'Extra EU',
              value: AddressBookUserOrigin.EXTRA,
            },
          ]}
        />
      </FormItem>

      {userOrigin && (
        <>
          <FormItem name="codiceFiscale" label="Codice Fiscale">
            <TextInput name="codiceFiscale" />
          </FormItem>

          <FormItem name="email" label="E-Mail">
            <TextInput name="email" />
          </FormItem>
          <RowElement>
            <FormItem name="nome" label="Nome">
              <TextInput name="nome" />
            </FormItem>
            <FormItem name="cognome" label="Cognome">
              <TextInput name="cognome" />
            </FormItem>
          </RowElement>
          <FormItem name="indirizzo" label="Indirizzo">
            <TextInput name="indirizzo" />
          </FormItem>
          <FormItem name="note" label="Note">
            <TextAreaInput name="note" rows={4} />
          </FormItem>
        </>
      )}
    </>
  );
}
